import styled from "styled-components/macro";

const breakpoints = {
  mobile: "screen and (max-width: 768px)",
  tablet: "screen and (max-width: 960px)",
  smallLaptop: "screen and (max-width: 1300px)",
  lg: "screen (max-width: 1530px)",
  xl: "screen and (min-width: 1531px)",
};

export const Container = styled.div`
  width: auto;
  padding-top: 0;
  margin: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;

  a {
    font-weight: 500;
    color: var(--primary-cta-high-contrast);
  }

  .plugin-card {
    margin-top: 24px;
    flex-grow: 1;
    height: 100%;
    margin-top: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    @media ${breakpoints.mobile} {
      max-width: calc(100vw - 96px);
    }

    .loading {
      text-align: center;
      margin-bottom: 45px;
    }
    h3 {
      font-weight: 500;
      color: var(--grey-1);
      padding-top: 6px;
    }

    background: var(--menu-color);
    box-shadow: var(--default-drop-shadow);
    border-radius: 24px;
    padding: 24px;
    .gray {
      background: #aaa !important;
    }

    .buttons {
      .main-buttons {
        display: flex;
        gap: 14px;
        align-items: center;
        flex-direction: row;
      }

      .text-button-inner,
      button {
        border: 2px solid var(--primary-cta-high-contrast) !important;
        border-radius: 10px;
        margin-top: 0px !important;
      }

      .text-button-inner,
      button.remove {
        background-color: white;
        color: var(--primary-cta-high-contrast) !important;
        &:hover {
          background-color: var(--menu-color-primary-cta-overlay-hover);
        }
        &:active {
          background-color: var(--menu-color-primary-cta-overlay-active);
        }
      }

      button {
        line-height: 24px;
        padding: 8px 10px;
      }

      .edit {
        border: none !important;
        svg {
          margin-left: -4px;
          path {
            stroke-width: 0.5;
            stroke: var(--primary-cta-high-contrast);
            fill: var(--primary-cta-high-contrast);
          }
        }
      }

      .report,
      .copy-link {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;

        svg {
          height: 24px;
          width: 24px;
        }

        &:before {
          opacity: 0;
          transition: opacity 0.2s linear;
          transition-delay: 0.2s;
          position: absolute;
          content: "";
        }

        &:hover {
          &:before {
            text-transform: none;
            position: absolute;
            opacity: 1;
            left: 50%;
            transform: translate(-50%, 10px);
            line-height: 20px;
            height: 20px;
            font-weight: 500;
            top: 33px;
            padding: 3px 8px;
            background-color: var(--grey-0);
            color: var(--context-menu-text);
            border-radius: 6px;
            font-size: 12px;
            white-space: nowrap;
            z-index: 1000;
          }
        }
      }

      .copy-link {
        margin-right: 8px;
        &:hover {
          &:before {
            content: "Copy link";
          }
        }
      }

      .report {
        svg {
          height: 18px;
          width: 18px;
        }

        &:hover {
          &:before {
            content: "Report";
          }
        }
      }
    }

    .header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;

      @media screen and (max-width: 960px) {
        flex-wrap: wrap;
        gap: 8px;
      }

      h1 {
        margin: 0;
        text-align: left;
        max-width: none;
        line-height: 1.3;
        color: var(--grey-0);
        max-width: 450px;
        text-wrap: balance;

        svg {
          path {
            fill: var(--grey-0);
          }
        }
      }

      .buttons {
        display: flex;
        align-items: center;

        @media ${breakpoints.tablet} {
          flex-direction: row-reverse;
          gap: 14px;
          margin-top: 10px;

          .report {
            display: none;
          }
        }
      }
    }

    .plugin-info {
      display: flex;
      align-items: stretch;
      gap: 10px;
      margin: 20px 0;
      overflow-x: auto;

      .plugin-info-box {
        border-radius: 12px;
        border: 1px solid #d9d9d9;
        padding: 15px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;

        svg {
          width: 30px;
          position: relative;
          top: 5px;
        }

        .subhead {
          font-size: 12px;
          font-style: normal;
          font-weight: 500;
          opacity: 0.5;
        }

        .main-info {
          font-family: GT Super Text;
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          white-space: nowrap;

          &.author {
            margin-top: 8px;
          }

          &.user-count {
            font-size: 30px;
          }

          &.credits {
            margin-left: 11px;
            .credit {
              margin-left: -15px;
              &.empty {
                opacity: 0.3;
              }
            }
          }
        }
      }
    }

    .plugin {
      font-weight: 500;
      color: var(--grey-0);
      padding-top: 6px;
      flex-grow: 2;

      .description,
      .prompts {
        color: #000;
        font-family: Inter;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%;
        text-align: left;
      }

      .prompts {
        margin-top: 24px;
        margin-bottom: 12px;
      }
      .prompt-block {
        p {
          font-family: Courier, monospace;
          span {
            font-family: Inter;
          }
        }
        font-weight: 500;
        line-height: 130%;
        padding: 12px 24px 24px 24px;
        border-radius: 12px;
        background-color: var(--menu-color-hover);
        margin-bottom: 24px;
        h3 {
          font-weight: 500;
          color: var(--grey-1);
        }
      }
    }

    footer {
      display: flex;
      flex-direction: row;
      gap: 15px;

      .last-updated {
        flex-grow: 1;
        text-align: center;
        opacity: 0.5;
        color: #000;
        font-size: 14px;
        margin-top: 1em;
      }
    }
  }
`;
